import englishMessages from "jazasoft/lib/i18n/default-messages/js-language-english";

// const englishMessages = i18n["js-language-english"];

const flowInfoFields = {
  flowRef: "लाइन आईडी",
  customerFlowRef: "बीपीओ",
  style: "स्टाइल नाम",
  styleNo: "स्टाइल नंबर",
  styleImage: "स्टाइल छवि",
  color: "स्टाइल रंग",
  fit: "फिट",
  productId: "उत्पाद",
  product: { name: "उत्पाद" },
  productName: "उत्पाद का नाम",
  ratio: "अनुपात",
  destination: "गंतव्य",
  delMode: "वितरण मोड",
  exFactoryDate: "वितरण तिथि",
  orderQty: "आदेश मात्रा",
  fpoQty: "एफपीओ मात्रा",
  uom: "यूनिट ऑफ मैज़रमेंट",
  extra: "अतिरिक्त शिप (%)",
  status: "स्थिति",
  customField1: "कस्टम फ़ील्ड 1",
  customField2: "कस्टम फ़ील्ड 2",
  customField3: "कस्टम फ़ील्ड 3"
};

const partFields = {
  partName: "पार्ट",
  placement: "स्थान",
  ocu: "बीओएम सीयू",
  bomCu: "बीओएम सीयू",
  uom: "यूनिट ऑफ मैज़रमेंट"
};

const orderFields = {
  poRef: "पीओ रेफरेंस",
  customerPoRef: "ग्राहक पीओ रेफरेंस",
  products: "उत्पाद",
  styles: "स्टाइल्स",
  seasonId: "सीजन",
  seasonName: "सीजन",
  customerId: "ग्राहक",
  customerName: "ग्राहक",
  color: "स्टाइल रंग",
  productId: "उत्पाद",
  season: { name: "सीजन" },
  customer: { name: "ग्राहक" },
  totalQty: "कुल मात्रा",
  desc: "विवरण",
  state: "स्थिति",
  part: partFields,
  flowInfo: flowInfoFields,
  selector: ""
};

const rollFields = {
  consignment: "सम्बन्ध",
  supplierRollNo: "प्रदाता रोल नंबर",
  factoryRollNo: "फैक्टरी रोल नंबर",
  rollNo: "रोल नंबर",
  length: "लंबाई",
  weight: "वजन",
  gsm: "जीएसएम",
  width: "चौड़ाई",
  warpShrValue: "लंबाई कमी वैल्यू",
  weftShrValue: "चौड़ाई कमी वैल्यू",
  warpShrPercent: "लंबाई कमी (%)",
  weftShrPercent: "चौड़ाई कमी (%)",
  warpPattern: "लंबाई पैटर्न (%)",
  weftPattern: "चौड़ाई पैटर्न (%)",
  patternNo: "पैटर्न नंबर",
  shade: "छाया",
  csv: "सीएसवी",
  skewnessValue: "विकृति (%)",
  skewness: "विकृति समूह",
  rackNo: "रैक नंबर",
  qcStatus: "क्यूसी स्थिति",
  invStatus: "इन्वेंटरी स्थिति"
};

const en = {
  ...englishMessages,
  app_name_short: "ऑप्टाकट",
  app_name_full: "ऑप्टिमिसेड फैब्रिक कट प्लानर",
  dashboard: "डैशबोर्ड",
  forbidden: {
    title: "फोर्बिडन",
    message: "एक्सेस डिनाइड. यू डू नॉट हैवे एनफ प्रिविलेज फॉर थिस पेज."
  },
  resources: {
    cuChecklists: {
      name: "सीयू चेकलिस्ट |||| सीयू चेकलिस्ट",
      fields: {
        cuChecklistId: "सीयू चेकलिस्ट आईडी",
        "customer.name": "ग्राहक",
        "season.name": "सीजन",
        "product.name": "उत्पाद",
        createdDate: "निर्मित तिथि",
        createdBy: "निर्माता",
        state: "स्थिति"
      }
    },
    costings: {
      name: "कॉस्टिंग |||| कॉस्टिंग",
      fields: {
        cstId: "कॉस्टिंग आईडी",
        "customer.name": "ग्राहक",
        "product.name": "उत्पाद",
        "season.name": "सीजन",
        createdDate: "निर्मित तिथि",
        createdBy: "निर्माता",
        state: "स्थिति",
        techSheets: "तकनीकी शीटें"
      }
    },
    estimations: {
      name: "अनुमान |||| अनुमान",
      fields: {
        estId: "अनुमान आईडी",
        poRef: "पीओ रेफरेंस",
        customerPoRef: "ग्राहक पीओ रेफरेंस",
        fit: "फिट",
        techSheet: "तकनीकी शीट",
        remarks: "टिप्पणियाँ",
        createdDate: "निर्मित तिथि",
        createdBy: "निर्माता",
        state: "स्थिति",
        colors: "रंग",
        "customer.name": "ग्राहक",
        "product.name": "उत्पाद",
        "season.name": "सीजन"
      }
    },
    "order-mngmt": {
      name: "ऑर्डर प्रबंधन"
    },
    orders: {
      name: "ऑर्डर",
      action: {
        next: "आगे बढ़ें"
      },
      button: {
        export_shell: "निर्यात (शैल)",
        export: "निर्यात"
      },
      fields: {
        ...orderFields,
        ...flowInfoFields
      },
      flowInfo: flowInfoFields,
      part: {
        name: "भाग",
        fields: {
          id: "आईडी",
          serial: "सीरियल नंबर",
          partName: "पार्ट नाम",
          placement: "प्लेसमेंट",
          ocu: "बीओएम उपभोग",
          bomCu: "बीओएम उपभोग",
          uom: "यूनिट ऑफ मेज़रमेंट",
          bomFabColor: "बीओएम फैब्रिक रंग",
          fabOrderQty: "फैब्रिक आदेश मात्रा",
          bomItemCode: "बीओएम आइटम कोड"
        }
      },
      sizeBreakup: {
        name: "साइज ब्रेकअप",
        fields: {
          id: "आईडी",
          serialNo: "सीरियल नंबर",
          serial: "सीरियल नंबर",
          sizeGroup: "साइज ग्रुप",
          size: "साइज",
          qty: "मात्रा"
        }
      }
    },
    planning: {
      name: "फैक्टरी प्लैनिंग"
    },
    fabrics: {
      name: "आइटम मास्टर",
      fields: {
        itemCode: "आइटम कोड",
        itemDesc: "आइटम विवरण",
        articleName: "आर्टिकल नाम",
        gsm: "जीएसएम",
        classification: "श्रेणी",
        fabricCategoryId: "फैब्रिक श्रेणी",
        fabricCategoryName: "फैब्रिक श्रेणी",
        fabricCategory: { name: "फैब्रिक श्रेणी" },
        fabricPatternId: "फैब्रिक पैटर्न",
        fabricPatternName: "फैब्रिक पैटर्न",
        fabricPattern: { name: "फैब्रिक पैटर्न" },
        repeatLength: "पुनरावृत्ति - लंबाई (सेंटीमीटर)",
        repeatWidth: "पुनरावृत्ति - चौड़ाई (सेंटीमीटर)",
        construction: "गिनती निर्माण",
        content: "सामग्री",
        remarks: "टिप्पणियाँ",
        fabricColors: "रंग",
        color: {
          color: "फैब्रिक रंग",
          swatchImage: "स्वैच इमेज"
        }
      },
      pageHeader: {
        create: "फैब्रिक बनाएं"
      },
      errors: {
        repeat_length_required: "पुनरावृत्ति लंबाई आवश्यक है",
        repeat_width_required: "पुनरावृत्ति चौड़ाई आवश्यक है",
        repeat_in_only_one_direction: "स्ट्राइप्स फैब्रिक केवल एक दिशा में पुनरावृत्ति कर सकता है।"
      }
    },
    invoices: {
      name: "फैब्रिक जीआरएन",
      fields: {
        invoiceNo: "चालान संख्या",
        erpInvoiceNo: "ईआरपी चालान संख्या",
        grn: "जीआरएन नंबर",
        invoiceQty: "कुल चालान मात्रा",
        warehouse: "गोदाम",
        warehouses: "गोदाम",
        supplierId: "आपूर्तिकर्ता",
        supplierName: "आपूर्तिकर्ता",
        supplier: { name: "आपूर्तिकर्ता" },
        association: {
          orderId: "पीओ रेफरेंस",
          productId: "उत्पाद",
          style: "स्टाइल नाम",
          color: "स्टाइल रंग",
          partId: "पार्ट",
          ocu: "बीओएम सीयू",
          bomCu: "बीओएम सीयू",
          orderQty: "ऑर्डर मात्रा",
          extra: "अतिरिक्त जहाज (%)",
          fabricRequired: "आवश्यक \nफैब्रिक",
          extraFabricRequired: "आवश्यक \nफैब्रिक (अतिरिक्त)",
          alreadyAssociatedQty: "पहले से ही \nएसोसिएटेड मात्रा",
          qty: "एसोसिएशन \nमात्रा"
        }
      },
      pageHeader: {
        create: "चालान बनाएं",
        edit: "चालान संपादित करें",
        view: "चालान देखें"
      }
    },
    fabricItems: {
      fields: {
        invoiceNo: "चालान संख्या",
        erpInvoiceNo: "ईआरपी चालान संख्या",
        fabricId: "आइटम कोड",
        itemCode: "आइटम कोड",
        itemDesc: "आइटम विवरण",
        articleName: "आर्टिकल नाम",
        classification: "श्रेणी",
        construction: "गिनती निर्माण",
        content: "सामग्री",
        color: "फैब्रिक रंग",
        poRef: "पीओ रेफरेंस",
        orderId: "पीओ रेफरेंस",
        fpo: "एफपीओ",
        orderQty: "फैब्रिक ऑर्डर मात्रा",
        invoiceQty: "चालान मात्रा",
        grn: "जीआरएन",
        grnDate: "जीआरएन तिथि",
        grnQty: "जीआरएन मात्रा",
        rollCount: "रोल संख्या",
        blanketQty: "रोल प्रति ब्लैंकेट मात्रा",
        orderingWidth: "बुकिंग विशालता",
        orderingGsm: "बुकिंग जीएसएम",
        orderingWarpShrinkage: "बुकिंग मैक्सिमम \nवार्प श्रिंकेज",
        orderingWeftShrinkage: "बुकिंग मैक्सिमम \nवेफ्ट श्रिंकेज"
      }
    },
    quality: {
      name: "गुणस्तर नियंत्रण |||| गुणस्तर नियंत्रण",
      fields: {
        ...orderFields,
        invoice: {
          invoiceNo: "चालान नंबर",
          erpInvoiceNo: "ERP चालान नंबर",
          itemCode: "आइटम कोड",
          itemDesc: "आइटम विवरण",
          articleName: "आर्टिकल नाम",
          classification: "वर्गीकरण",
          construction: "गणना निर्माण",
          content: "सामग्री",
          color: "कपड़े का रंग",
          associatedQty: "संबंधित मात्रा",
          allocatedQty: "आवंटित मात्रा"
        }
      }
    },
    rolls: {
      fields: rollFields
    },
    "fab-release": {
      name: "फैब्रिक रिलीज |||| फैब्रिक रिलीज",
      fields: {
        poRef: "पीओ रेफरेंस",
        customerPoRef: "ग्राहक पीओ रेफरेंस",
        flowRefs: "लाइन आईडी",
        flowRef: "लाइन आईडी",
        customerFlowRefs: "बीपीओs",
        customerFlowRef: "बीपीओ",
        customer: "ग्राहक",
        productName: "उत्पाद",
        style: "स्टाइल",
        styles: "स्टाइल्स",
        colors: "रंग",
        color: "रंग",
        inseams: "इनसीम्स",
        inseam: "इनसीम",
        destinations: "गंतव्य",
        destination: "गंतव्य",
        deliveries: "वितरण",
        deliveryDate: "वितरण तिथि",
        part: "पार्ट",
        lotValue: "लॉट",
        orderQty: "आदेश मात्रा",
        itemCode: "आइटम कोड",
        itemDesc: "आइटम विवरण",
        articleName: "आर्टिकल नाम",
        allocatedQty: "आवंटित मात्रा",
        releasedQty: "रिलीज की गई मात्रा"
      }
    },
    grouping: {
      name: "समूहीकरण |||| समूहीकरण",
      fields: {
        ...orderFields,
        warpInterval: "लंबाई श्रिंकेज इंटरवल (%)",
        weftInterval: "चौड़ाई श्रिंकेज इंटरवल (%)",
        widthWastePercent: "चौड़ाई कचरा कटौती (%)",
        fabAllocPlusValue: "आवंटन प्लस सहिष्णुता",
        fabAllocMinusValue: "आवंटन माइनस सहिष्णुता",
        minRollSplitQty: "न्यूनतम रोल स्प्लिट लंबाई",
        groupingWastage: "चौड़ाई कचरा",
        flowInfo: {
          ...flowInfoFields,
          styleColor: "स्टाइल रंग",
          part: "पार्ट",
          partName: "पार्ट",
          placement: "स्थान",
          lot: "लॉट",
          itemCode: "आइटम कोड",
          fabColor: "कपड़े का रंग",
          fabricRequired: "Fab. आवश्यक \n100% में",
          extraFabricRequired: "Fab. आवश्यक \nअतिरिक्त के साथ",
          totalAssociation: "कुल \nएसोसिएशन मात्रा",
          alreadyAllocated: "पहले से ही \nआवंटित मात्रा",
          allocated: "आवंटित \nकपड़ा",
          balanceAssociation: "शेष \nएसोसिएशन मात्रा",
          association: "एसोसिएशन मात्रा",
          manuallyAllocated: "मैन्युअली \nआवंटित मात्रा",
          shadeReady: "छाया \nतैयार",
          shrinkageReady: "श्रिंकेज \nतैयार",
          qcReady: "क्यूसी \nतैयार"
        },
        shadeAllocation: {
          style: "स्टाइल",
          color: "स्टाइल रंग",
          destination: "गंतव्य",
          deliveryDate: "वितरण तिथि",
          associatedQty: "एसोसिएटेड मात्रा"
        }
      }
    },
    cutPlan: {
      name: "कट योजना"
    },
    bulk: {
      name: "थोक |||| थोक कट प्लान",
      header: {
        bulk: "थोक कट ऑर्डर",
        pre_run: "प्री-रन कट ऑर्डर"
      },
      title: {
        pending_orders: "अपूर्ण आदेश",
        cut_order: "कट ऑर्डर"
      },
      fields: {
        ...orderFields,
        flowInfo: {
          ...flowInfoFields,
          styleColor: "स्टाइल रंग",
          lot: "लॉट",
          lotValue: "लॉट",
          part: "पार्ट",
          placement: "स्थान",
          partName: "पार्ट",
          bomCu: "बीओएम सीयू",
          deliveryDate: "वितरण तिथि",
          itemCode: "आइटम कोड",
          fabColor: "फैब्रिक रंग",
          fabricPattern: "फैब्रिक पैटर्न",
          reapet: "रीपीट",
          width: "ओ. चौड़ाई",
          allocatedQty: "आवंटित फैब्रिक",
          allocated: "आवंटित \nफैब्रिक",
          expCutQty: "अपेक्षित कट मात्रा",
          extraPercent: "अतिरिक्त शिप (%)",
          extraFab: "अतिरिक्त फैब्रिक",
          rejected: "अस्वीकृत",
          reserved: "रिजर्व्ड",
          planned: "ले में योजना बनाई गई",
          tentPlanned: "ले में योजना बनाई गई (अपेक्षित)",
          tentEndBits: "एंड बिट्स (अपेक्षित)",
          endBits: "एंड बिट्स",
          shortageExcess: "कमी/अधिशेष",
          missing: "गायब",
          orderingCu: "बीओएम सीयू",
          layCu: "ले सीयू",
          tentActualCu: "असली सीयू (अपेक्षित)",
          actualCu: "असली सीयू"
        },
        multiPartBundling: "योजना प्रकार",
        maxPieces: "प्रति तरीके का अधिकतम वस्त्र",
        maxPliesInLay: "ले में अधिकतम प्लाइज़",
        fabricDirection: "फैब्रिक दिशा",
        line: "लाइन",
        discardedWays: "छोड़ी गई रास्ते",
        proportionalShade: "पैम्बल साझेदारी",
        reserveType: "पैनल पुनर्स्थापन रिजर्वेशन प्रकार",
        reserveQty: "पैनल पुनर्स्थापन रिजर्वेशन मात्रा",
        cutAll: "सभी को काटें",
        layType: "ले प्रकार",
        allowOneWayCsv: "शेष में एक रास्ता अनुमति दें",
        markerType: "मार्कर प्रकार",
        plyPairPerRoll: "प्लाई पेयरिंग प्रति रोल",
        cutConstant: "कट स्थिर [4,5,6]",
        wayMaximizeConstant: "रास्ते में अधिकतमीकरण स्थिर [0, 25, 50, 75]",
        sizeExhaustConstant: "साइज़ खत्म होने का स्थिर [0, 25, 50, 75, 100]",
        sizeMixingConstant: "साइज़ मिश्रण स्थिर [0, 25, 50, 75]",
        preferHigherSizeConstant: "उच्च साइज स्थिर [0, 25, 50, 75, 100]",
        mainWidthReGroupingTolerance: "चौड़ाई पुनरसमूहन सहिष्णुता (मुख्य)",
        remnantWidthReGroupingTolerance: "चौड़ाई पुनरसमूहन सहिष्णुता (शेष)",
        mainCutOffPercent: "मुख्य मार्कर के लिए कट-ऑफ प्रतिशत",
        endBitCsvMultiplier: "एंड बिट सीएसवी मल्टीप्लायर",
        plyLimit: "प्लाई सीमा",
        maxRatio: "किसी भी साइज के लिए अधिकतम अनुपात",
        skipZeroSizeRank: "शून्य साइज रैंक को छोड़ें"
      }
    },
    prerun: {
      name: "प्री रन |||| प्री रन"
    },
    rollPlan: {
      name: "रोल प्लान",
      title: {
        cut_order: "कट ऑर्डर"
      },
      fields: {
        ...orderFields,
        setting: {
          recLayHeight: "शुद्ध ले की ऊचाई",
          layHeightTolerance: "ले की ऊचाई सहिष्णुता",
          layType: {
            all_mix: "सभी मिश्रित",
            shade_wise: "छाया के अनुसार",
            color_wise: "रंग के अनुसार",
            size_group_wise: "साइज़ ग्रुप के अनुसार"
          }
        },
        layslip: {
          sizeGroup: "साइज़ ग्रुप",
          marker: "मार्कर",
          markerNo: "मार्कर नंबर",
          length: "मार्कर लंबाई",
          layLength: "ले लंबाई",
          shrinkage: "श्रिंकेज",
          way: "रास्ता",
          layNo: "ले नंबर",
          plies: "प्लाइज़",
          rollCount: "रोल की संख्या",
          width: "चौड़ाई",
          pattern: "पैटर्न",
          csv: "सीएसवी"
        }
      }
    },
    layslip: {
      name: "ले स्लिप",
      title: {
        cut_order: "कट ऑर्डर"
      },
      fields: {
        ...orderFields,
        layslip: {
          sizeGroup: "साइज़ ग्रुप",
          marker: "मार्कर",
          layLength: "ले लंबाई",
          way: "रास्ता",
          layNo: "ले नंबर",
          plies: "योजनाबद्ध प्लाइज़",
          rollCount: "रोल की संख्या"
        },
        fabricUsage: {
          style: "स्टाइल",
          color: "रंग",
          allocated: "आवंटित",
          extra: "अतिरिक्त",
          reserved: "रिजर्व्ड",
          rejected: "अस्वीकृत",
          usedInLay: "उपयोग किया गया",
          endBits: "एंड बिट्स",
          usedInPanel: "पैनल पुनर्स्थापन में उपयोग किया गया",
          liveCu: "लाइव कंस.",
          shortageExcess: "कमी/अधिशेष फैब्रिक",
          expShortageExcessPcs: "अपेक्षित कमी/अधिशेष पीस"
        }
      }
    },
    partRecutting: {
      name: "पैनल पुनर्स्थापन",
      fields: orderFields,
      tabs: {
        panel_summary: "पैनल सारांश",
        fabric_usage: "फैब्रिक उपयोग",
        traceability: "ट्रेसेबिलिटी"
      }
    },
    garmentRecutting: {
      name: "गारमेंट पुनर्स्थापन",
      fields: orderFields
    },
    garmentRejection: {
      name: "गारमेंट रिजेक्शन",
      fields: orderFields
    },
    orderClosure: {
      name: "आदेश समापन",
      fields: orderFields
    },
    report: {
      fields: orderFields,
      arr: {
        excelColumns: {
          orderCloseDate: "बंद करने की तारीख",
          cuttingCompletedDate: "कटाई की गई तारीख",
          line: "लाइन/मंज़िल/कारख़ाना",
          poRef: "ईआरपी नंबर",
          customer: "ग्राहक",
          season: "खरीदार",
          style: "स्टाइल",
          styleColor: "स्टाइल रंग",
          styleNo: "स्टाइल नंबर",
          part: "पार्ट",
          lot: "लॉट",
          orderQty: "आर्डर मात्रा",
          cutQty: "कटाई मात्रा",
          rejectedQty: "अस्वीकृत मात्रा",
          allocated: "फैब्रिक आवंटित",
          returned: "वापसी",
          missing: "मिस्ड",
          unused: "अनयूज्ड",
          shortage: "कमी/अधिशेष",
          excess: "अधिशेष",
          shortageExcess: "कमी/अधिशेष",
          fabricUsed: "फैब्रिक का उपयोग",
          available: "उपयोग के लिए उपलब्ध",
          usedInLayPlanned: "योजनित मार्कर में उपयोग किया गया",
          usedInLayRecutting: "गारमेंट रीकटिंग में उपयोग किया गया",
          endLoss: "एंड लॉस",
          endBits: "वास्तविक एंड बिट्स",
          damaged: "क्षतिग्रस्त",
          usedInPanel: "पैनल पुनर्स्थापन में उपयोग किया गया",
          wastage: "कुल वेस्टेज",
          wastagePercent: "वेस्टेज (%)",
          orderingCu: "बीओएम सीयू",
          layCu: "ले सीयू",
          actualCu: "अद्यतन सीयू",
          misCu: "मिस सीयू",
          cuDiff: "सीएम में सीयू अंतर",
          markerEfficiency: "मार्कर प्रदर्शन",
          supplier: "प्रदाता",
          fabricPattern: "फैब्रिक प्रकार",
          fabDirection: "फैब्रिक दिशा",
          isCsv: "सीएसवी",
          fabRepeat: "फैब्रिक पुनरावृत्ति",
          width: "फैब्रिक बॉम चौड़ाई (सेंटीमीटर में)",
          actualWidth: "फैब्रिक वास्तविक चौड़ाई (सेंटीमीटर में)",
          alerts: "चेतावनियाँ",
          remarks: "टिप्पणियाँ"
        }
      },
      cutting: {
        date: "Date",
        unit: "Unit",
        poRef: "ERP No",
        fpo: "FPO No",
        customer: "Customer",
        season: "Season",
        product: "Product",
        style: "Style Name",
        color: "Style Color",
        part: "Part",
        lotValue: "Lot",
        inseams: "inseams",
        destinations: "Destinations",
        deliveries: "deliveries",
        delModes: "Delivery Modes",
        customerFlowRefs: "BPO",
        flowRefs: "Line ID",
        orderQty: "Order Qty",
        fpoQty: "FPO Qty",
        cutQty: "Cut Qty",
        cumCutQty: "Cum. Cut Qty"
      }
    },
    users: {
      name: "उपयोगकर्ता |||| उपयोगकर्ता",
      page: {
        create: "उपयोगकर्ता बनाएं",
        edit: "उपयोगकर्ता संपादित करें",
        view: "उपयोगकर्ता देखें",
        upload: "उपयोगकर्ता अपलोड करें"
      },
      title: {
        excel_file: "एक्सेल फ़ाइल"
      },
      error: {
        roles_required: "भूमिकाएँ आवश्यक हैं।",
        customer_required: "ग्राहक भूमिका के लिए ग्राहक आवश्यक है। %{role}.",
        warehouse_required: "भंडार के लिए भूमिका के लिए भंडार आवश्यक है। %{role}.",
        not_valid_selection: "एडमिन भूमिका को अन्य भूमिकाओं के साथ मिलाया नहीं जा सकता"
      },
      errors: {
        invalid_username: "अवैध उपयोगकर्ता नाम। केवल अक्षर (a-z, A-Z), संख्या (0-9), हाइफ़न (-), अंडरस्कोर (_) का उपयोग कर सकते हैं।",
        invalid_email: "अवैध ईमेल।"
      },
      message: {
        activated: "उपयोगकर्ता सफलतापूर्वक सक्रिय हुआ।",
        deactivated: "उपयोगकर्ता सफलतापूर्वक निष्क्रिय हुआ।"
      },
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        fullName: "पूरा नाम",
        username: "उपयोगकर्ता नाम",
        email: "ईमेल",
        mobile: "मोबाइल",
        roles: "भूमिकाएँ",
        roleIds: "भूमिकाएँ",
        departmentId: "विभाग"
      }
    },
    customers: {
      name: "ग्राहक |||| ग्राहक",
      page: {
        create: "ग्राहक बनाएं",
        edit: "ग्राहक संपादित करें"
      },
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "ग्राहक",
        code: "कोड",
        desc: "विवरण"
      }
    },
    alertReasons: {
      name: "अलर्ट कारण |||| अलर्ट कारण",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        parameter: "पैरामीटर",
        reason: "कारण"
      }
    },
    suppliers: {
      name: "आपूर्तिकर्ता |||| आपूर्तिकर्ता",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "आपूर्तिकर्ता",
        desc: "विवरण"
      }
    },
    seasons: {
      name: "सीजन |||| सीजन",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "सीजन",
        desc: "विवरण"
      }
    },
    tables: {
      name: "तालिका |||| तालिकाएँ",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "तालिका",
        desc: "विवरण"
      }
    },
    units: {
      name: "इकाइयाँ |||| इकाइयाँ",
      fields: {
        name: "इकाई",
        desc: "विवरण",
        unitId: "इकाई आईडी"
      },
      errors: {
        invalid_unit_id: "अवैध इकाई आईडी। केवल अक्षर (a-z, A-Z), संख्या (0-9), हाइफ़न (-), अंडरस्कोर (_) का उपयोग कर सकते हैं।"
      }
    },
    departments: {
      name: "विभाग |||| विभाग",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "विभाग",
        desc: "विवरण"
      }
    },
    warehouses: {
      name: "गोदाम |||| गोदाम",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "गोदाम",
        desc: "विवरण"
      },
      errors: {
        invalid_code: "अवैध कोड। केवल अक्षर (a-z, A-Z), संख्या (0-9), हाइफ़न (-), अंडरस्कोर (_) का उपयोग कर सकते हैं।"
      }
    },
    "system-activities": {
      name: "सिस्टम गतिविधि |||| सिस्टम गतिविधियाँ",
      fields: {
        name: "सिस्टम गतिविधि",
        searchText: "एंटिटी मूल्य",
        createdAt: "समय",
        createdBy: "उपयोगकर्ता"
      }
    },
    reCutParts: {
      name: "रीकटिंग पार्ट |||| रीकटिंग पार्ट्स",
      fields: {
        name: "पार्ट",
        category: "श्रेणी"
      }
    },
    bundleParts: {
      name: "बंडल पार्ट |||| बंडल पार्ट्स",
      fields: {
        name: "टेम्पलेट नाम",
        parts: "पार्ट्स"
      }
    },
    sizes: {
      name: "साइज |||| साइज़ेस",
      fields: {
        name: "साइज",
        desc: "विवरण"
      }
    },
    "fabric-patterns": {
      name: "फैब्रिक पैटर्न |||| फैब्रिक पैटर्न्स",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "फैब्रिक पैटर्न",
        desc: "विवरण"
      }
    },
    products: {
      name: "उत्पाद |||| उत्पाद",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "उत्पाद",
        bundleParts: "बंडल पार्ट्स",
        desc: "विवरण",
        isSet: "क्या सेट है?"
      }
    },
    downloads: {
      name: "टेम्पलेट |||| टेम्पलेट्स"
    },
    "fabric-categories": {
      name: "फैब्रिक श्रेणी |||| फैब्रिक श्रेणियाँ",
      fields: {
        id: "आईडी",
        unitIds: "इकाइयाँ",
        name: "फैब्रिक श्रेणी",
        desc: "विवरण"
      }
    },
    externalApps: {
      name: "रजिस्टर्ड ऐप |||| रजिस्टर्ड एप्स",
      fields: {
        name: "एप्लिकेशन",
        appId: "एप्प आईडी",
        integrationType: "इंटीग्रेशन प्रकार",
        enabled: "सक्रिय",
        serviceClass: "सेवा कक्ष",
        authConfig: "एथ कॉन्फ़िग",
        authServiceClass: "एथ सेवा कक्ष"
      }
    },
    apiKeys: {
      name: "एपीआई की |||| एपीआई कीज",
      fields: {
        appId: "एप्प आईडी",
        active: "सक्रिय"
      }
    },
    help: {
      name: "सहायता केंद्र"
    },
    manual: {
      name: "उपयोगकर्ता मैनुअल"
    },
    test: {
      name: "परीक्षण पृष्ठ"
    },
    scheduledTask: {
      name: "निर्धारित कार्य |||| निर्धारित कार्य",
      pageHeader: {
        home: "निर्धारित कार्य"
      },
      button: {
        stop: "रोकें",
        cancel: "रद्द करें"
      }
    }
  },
  js: {
    action: {
      delete: "डिलीट",
      show: "शो",
      view: "व्यू",
      list: "लिस्ट",
      history: "हिस्ट्री",
      save: "सेव",
      next: "नेक्स्ट",
      submit: "सबमिट",
      create: "क्रिएट",
      edit: "एडिट",
      upload: "अपलोड",
      download: "डाउनलोड",
      sort: "सॉर्ट",
      close: "क्लोज",
      cancel: "कैंसिल",
      clear_input_value: "क्लियर वैल्यू",
      undo: "अनडू",
      refresh: "रिफ्रेश",
      add: "ऐड",
      remove: "रिमूव",
      filter: "फ़िल्टर",
      add_filter: "ऐड फ़िल्टर",
      remove_filter: "रिमूव थिस फ़िल्टर",
      back: "बैक",
      bulk_actions: "%{smart_count} सिलेक्टेड"
    },
    boolean: {
      true: "यस",
      false: "नो"
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "क्रिएट %{name}",
      bulk_upload: "%{name} बल्क अपलोड",
      dashboard: "डैशबोर्ड",
      not_found: "नॉट फाउंड",
      loading: "लोडिंग"
    },
    tab: {
      show: "व्यू %{name}",
      create: "क्रिएट %{name}",
      edit: "अपडेट %{name}"
    },
    input: {
      file: {
        upload_several: "ड्राप सम फाइल्स तो अपलोड",
        upload_single: " और क्लिक तो सेलेक्ट ओने."
      },
      image: {
        upload_several: "ड्राप सम पिक्टुरेस तो अपलोड",
        upload_single: " और क्लिक तो सेलेक्ट ओने."
      },
      references: {
        all_missing: "ुनाबले तो फंड रेफरेन्सेस डाटा.",
        many_missing: "ात लीस्ट ओने ऑफ़ थे एसोसिएटेड रेफरेन्सेस नो लॉन्गर अप्पेअर्स तो बे अवेलेबल.",
        single_missing: "एसोसिएटेड रिफरेन्स नो लॉन्गर अप्पेअर्स तो बे अवेलेबल."
      }
    },
    message: {
      yes: "यस",
      no: "नो",
      are_you_sure: "अरे यु सूरे?",
      about: "अबाउट",
      not_found: "ऐथेर यु टाइप्ड ा रॉंग यूआरएल",
      loading: " और यु फोल्लोवेद आ बद लिंक.",
      invalid_form: "थे पेज इस लोडिंग",
      delete_title: " जस्ट ा मोमेंट प्लीज",
      delete_content: "थे फॉर्म इस नॉट वैलिड. प्लीज चेक फॉर िर्रोर्स",
      bulk_delete_title: "डिलीट %{name} #%{id}",
      bulk_delete_content: "अरे यु सूरे यू वांट तो डिलीट थिस आइटम?",
      data_not_available: "डिलीट %{name} ",
      drop_file: "अरे यु सूरे यू वांट तो डिलीट थिस %{name}? ",
      file_size_limit: "डाटा नॉट अवेलेबल"
    },
    navigation: {
      no_results: "नो रिजल्ट्स फाउंड",
      no_more_results: "थे पेज नंबर %{page} इस आउट ऑफ़ बौंडरीएस. तरय थे प्रीवियस पेज.",
      page_out_of_boundaries: "पेज नंबर %{page} आउट ऑफ़ बौंडरीएस",
      page_out_from_end: "कन्नोत गो आफ्टर लास्ट पेज",
      page_out_from_begin: "कन्नोत गो बिफोर पेज १",
      page_range_info: "%{offsetBegin}-%{offsetEnd} ऑफ़ %{total}",
      next: "नेक्स्ट",
      prev: "पर्व"
    },
    auth: {
      username: "यूजरनाम",
      password: "पासवर्ड",
      sign_in: "सिग्न इन",
      sign_in_error: "ऑथेंटिकेशन फेल्ड. यूजरनाम और पासवर्ड यु हैवे इंटरएड इस इनवैलिड.",
      logout: "लॉगआउट",
      password_reset_success: "पासवर्ड रिसेट सक्सेस्स्फुल्ली.",
      password_change_success: "पासवर्ड चेंज्ड सक्सेस्स्फुल्ली."
    },
    notification: {
      updated: "%{element} अपडेटेड सक्सेस्स्फुल्ली. ",
      created: "%{element} क्रिएटेड सक्सेस्स्फुल्ली.",
      deleted: "%{element} देलेटेड सक्सेस्स्फुल्ली. ",
      bad_item: "इनकरेक्ट %{element}",
      item_doesnt_exist: "%{element} डस नॉट एक्सिस्ट",
      http_error: "सर्वर कम्युनिकेशन एरर",
      canceled: "एक्शन कांसेल्लेड",
      uploaded: "%{element} उप्लोडेड सक्सेस्स्फुल्ली."
    },
    validation: {
      required: "रिक्वायर्ड",
      minLength: "मस्ट बे %{min} चरक्टेर्स ात लीस्ट",
      maxLength: "मस्ट बे %{max} चरक्टेर्स और लेस्स",
      minValue: "मस्ट बे ात लीस्ट %{min}",
      maxValue: "मस्ट बे %{max} और लेस्स",
      betweenValue: "मस्ट बे बिटवीन (%{min}, %{max})",
      number: " %{max})",
      email: "मस्ट बे ए नंबर",
      oneOf: "मस्ट बे अ वैलिड ईमेल",
      regex: "मस्ट बे ओने ऑफ़: %{pattern}"
    },
    alert: {
      confirm_delete: "डिलीट %{record}?",
      form_error: "फॉर्म हास् एरर. रिव्यु फॉर्म िर्रोर्स."
    }
  }
};

export default en;
